import { render, staticRenderFns } from "./FormularioTalleres.vue?vue&type=template&id=40b56387&scoped=true&"
import script from "./FormularioTalleres.vue?vue&type=script&lang=ts&"
export * from "./FormularioTalleres.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioTalleres.vue?vue&type=style&index=0&id=40b56387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b56387",
  null
  
)

export default component.exports